<template lang="pug">
section
  div
    | Key contact will act
    | as the main point of contact
    | between your company and the Home Office.

  br

  div
    | ✅
    | Requirements:

  ul
    li
      | there can only be ONE Key contact;
    li
      | hey do not have automatic access to the SMS.
      | If they require access to the system,
      | they will need to be set up
      | as a Level 1 or Level 2 user.
</template>

<script>
export default {
  name: "key_personnel_contact",
};
</script>